import { render, staticRenderFns } from "./BiddingHistory.vue?vue&type=template&id=fcaf626a"
import script from "./BiddingHistory.vue?vue&type=script&lang=js"
export * from "./BiddingHistory.vue?vue&type=script&lang=js"
import style0 from "./BiddingHistory.vue?vue&type=style&index=0&id=fcaf626a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports